export default __webpack_public_path__ + "static/media/73b153e58be6c566.073db0736fb86bc019bc6525d561fadc.svg";